import { useLocale } from "designSystem/locale";
import React, { FunctionComponent } from "react";
import MessageDialog, { MessageDialogProps } from "./MessageDialog";

export interface ErrorDialogProps extends Omit<MessageDialogProps, "category"> {
	/** message will be derived from error if provided, and message was not otherwise specified */
	error?: Error;
}

const ErrorDialog: FunctionComponent<ErrorDialogProps> = (props) => {
	const { error, message, messageRes, messageResParams, titleRes, ...otherProps } = props;
	let messageProp = message;
	let messageResProp = messageRes;
	let titleResProp = titleRes;

	if (!message && !messageRes) {
		if (error) {
			messageProp = useLocale()
				.getErrorMessage(error);
		} else {
			messageResProp = "RequestErrorMessage";
		}
	}

	if (!props.title && !titleRes) {
		titleResProp = "RequestError";
	}

	return (
		<MessageDialog
			category="error"
			message={messageProp}
			messageRes={messageResProp}
			messageResParams={messageResParams}
			titleRes={titleResProp}
			{...otherProps}
		/>
	);
};

export default ErrorDialog;